import { saveAs } from 'file-saver';
import { BACKEND_URL_PREFIX } from '../assets/const'
import { getFilenameFromContentDisposition, getFileUrl } from '../utils/smallHelpers';
import { SET_RECORDS_LIST, SET_RESUME_LOADING, SET_RESUME_RECORD_ID, SET_RESUME_RECORDS, SET_RESUME_TRANSCRIPTIONS, SET_TRANSCRIPTIONS_LIST } from './types'



export const getToken = (roomName, participantName, metadata) => async (dispatch) => {
  const response = await fetch(BACKEND_URL_PREFIX + "/token", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ roomName, participantName, metadata }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(`Failed to get token: ${error.errorMessage}`);
  }

  const data = await response.json();
  return data.token;
}


export const startRecord = (roomName) => async (dispatch) => {
  try {
    dispatch({type: SET_RESUME_LOADING, payload: true})
    
    const response = await fetch(BACKEND_URL_PREFIX + "/recordings/start", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ roomName }),
    });
    if (response.ok) {
      const respData = await response.json();
      dispatch({ type: SET_RESUME_RECORD_ID, payload: respData.recording.egressId });
    }
  } catch (ERR) {
  } finally {
    dispatch({type: SET_RESUME_LOADING, payload: false})
  }
}

export const stopRecord = (egressId) => async (dispatch, getState) => {
  try {
    dispatch({type: SET_RESUME_LOADING, payload: true})
    
    const response = await fetch(BACKEND_URL_PREFIX + "/recordings/stop", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ egressId }),
    })
    if (response.ok) {
      dispatch({ type: SET_RESUME_RECORD_ID, payload: null });
    }
  } catch (ERR) {
  } finally {
    dispatch({type: SET_RESUME_LOADING, payload: false})
  }
}

export const getRecordsList = (roomName, active) => async (dispatch) => {
  const urlParams = new URLSearchParams({ roomName, active }).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/recordings/list?${urlParams}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });
  if (response.ok) {
    const respData = await response.json();
    const payload = respData.recordings
    dispatch({ type: SET_RESUME_RECORDS, payload });
  }
}

export const getTranscritionsList = (roomName) => async (dispatch) => {
  const urlParams = new URLSearchParams({ roomName }).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/transcriptions?${urlParams}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });
  if (response.ok) {
    const respData = await response.json();
    const payload = respData.transcription_files
    dispatch({ type: SET_RESUME_TRANSCRIPTIONS, payload });
  }
}

export const getFile = (fileName, mode) => async (dispatch) => {
  const url = getFileUrl(fileName, mode)
  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });
  if (response.ok) {
    const blob = await response.blob();
    const contentDisposition = response.headers.get('Content-Disposition')
    const loadName = getFilenameFromContentDisposition(contentDisposition)
    saveAs(blob, loadName);
  }
}